import withStyles from 'isomorphic-style-loader/withStyles';
import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import s from './Header.css';
import Link from '../Link';
import Navigation from '../Navigation';

/**
 * Composant Header - En-tête principal de l'application
 * 
 * @component
 * @param {Object} props - Props du composant
 * @param {Object} props.context - Contexte de l'application
 * @param {Object} props.me - Utilisateur connecté
 * @param {Function} props.emitEvent - Fonction d'émission d'événements
 * @param {Function} props.t - Fonction de traduction
 * @returns {JSX.Element} Composant Header rendu
 */
const Header = ({ context, me, emitEvent, t, ...props }) => {
  return (
    <div className={s.pageHeader}>
      <div className={s.container}>
        <Navigation 
          context={context}
          me={me}
          emitEvent={emitEvent}
          t={t}
          {...props}
        />
        <div className={s.banner}>
          <Link className={s.link} to="/">
            <img src="/LOGO.svg" width="250px" alt="Logo" />
          </Link>
        </div>
      </div>
    </div>
  );
};

// PropTypes complets
Header.propTypes = {
  context: PropTypes.object,
  me: PropTypes.object,
  emitEvent: PropTypes.func,
  t: PropTypes.func.isRequired,
};

export default withTranslation()(withStyles(s)(Header));
